import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `audit`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'access',
  permission: 'audit.read',
} satisfies AdminPageAccessRule;
